import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent, ref } from "vue";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import i18n from "@/lang";
import dayjs from "dayjs";
import NotificationService from "@/services/notification.service";
import { EventType } from "@smeetz/compliance-common";
import { processAdditionalEvents, generateFdmDateTime } from "@/utils/helpers/compliance";
import { LogService } from "@/services/logging";
import { base64toPdfBlob } from "@/utils/vue-helpers/badges";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: ModalComponents.FiscalReports,
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var modalVisible = dialogVisibleForStatus(ModalStatus.FiscalReports);
    var yesterday = dayjs().subtract(1, "day").toDate();
    var zUserReportDate = ref(yesterday);
    var zTurnoverReportDate = ref(yesterday);
    var zUserSimulationReportDate = ref(new Date());
    var zTurnoverSimulationReportDate = ref(new Date());
    var loading = ref(false);

    function disabledDate(date) {
      var today = dayjs().startOf("day");
      var selectedDate = dayjs(date).startOf("day"); // Disable today, future dates and dates before sales started being processed by the FDM

      return selectedDate.isSame(today, "day") || selectedDate.isAfter(today) || selectedDate.isBefore(dayjs(process.env.VUE_APP_FDM_DATE || "2025-08-21").startOf("day"));
    }

    function disabledPrint(reportType) {
      var selectedDate = reportType === "user" ? zUserReportDate.value : zTurnoverReportDate.value; // Disable print if the selected date is today or in the future

      return disabledDate(selectedDate);
    }

    function printReport(_x) {
      return _printReport.apply(this, arguments);
    }

    function _printReport() {
      _printReport = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(reportType) {
        var dict, reportName, reportDate, periodStart, periodEnd, _result$data, result, base64pdf, blob, url, uniqueWindowName;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Map report types to their corresponding event types and translations
                dict = {
                  xUser: {
                    translation: i18n.global.t("compliance.x-user-report"),
                    eventType: EventType.REPORT_USER_X
                  },
                  xTurnover: {
                    translation: i18n.global.t("compliance.x-turnover-report"),
                    eventType: EventType.REPORT_TURNOVER_X
                  },
                  zUser: {
                    translation: i18n.global.t("compliance.z-user-report"),
                    eventType: EventType.REPORT_USER_Z
                  },
                  zTurnover: {
                    translation: i18n.global.t("compliance.z-turnover-report"),
                    eventType: EventType.REPORT_TURNOVER_Z
                  },
                  zUserSimulation: {
                    translation: "".concat(i18n.global.t("compliance.z-user-report"), " (Simulation)"),
                    eventType: EventType.REPORT_USER_Z_SIMULATION
                  },
                  zTurnoverSimulation: {
                    translation: "".concat(i18n.global.t("compliance.z-turnover-report"), " (Simulation)"),
                    eventType: EventType.REPORT_TURNOVER_Z_SIMULATION
                  }
                };
                reportName = dict[reportType].translation;

                if (!reportType.startsWith("z")) {
                  _context.next = 12;
                  break;
                }

                _context.t0 = reportType;
                _context.next = _context.t0 === "zUser" ? 6 : _context.t0 === "zTurnover" ? 8 : 10;
                break;

              case 6:
                reportDate = zUserReportDate.value;
                return _context.abrupt("break", 10);

              case 8:
                reportDate = zTurnoverReportDate.value;
                return _context.abrupt("break", 10);

              case 10:
                _context.next = 14;
                break;

              case 12:
                periodStart = generateFdmDateTime(dayjs().startOf("day").toDate());
                periodEnd = generateFdmDateTime(dayjs().endOf("day").toDate());

              case 14:
                _context.prev = 14;
                loading.value = true;
                _context.next = 18;
                return processAdditionalEvents(dict[reportType].eventType, {
                  reportDate: reportDate,
                  periodStart: periodStart,
                  periodEnd: periodEnd
                });

              case 18:
                result = _context.sent;
                LogService.info("Compliance: report generated", {
                  result: result
                });
                base64pdf = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.pdfBase64;

                if (base64pdf) {
                  _context.next = 24;
                  break;
                }

                NotificationService.showCustomError("".concat(t("compliance.no-pdf-data-for"), " ").concat(reportName, "."));
                return _context.abrupt("return");

              case 24:
                blob = base64toPdfBlob(base64pdf);
                url = URL.createObjectURL(blob);
                uniqueWindowName = "fileDownload_".concat(Date.now());
                window.open(url, uniqueWindowName);
                NotificationService.showCustomSuccess("".concat(reportName, " ").concat(t("compliance.printed-successfully"), "!"));
                _context.next = 34;
                break;

              case 31:
                _context.prev = 31;
                _context.t1 = _context["catch"](14);
                LogService.info("Error processing Report event", {
                  error: _context.t1
                });

              case 34:
                _context.prev = 34;
                loading.value = false;
                return _context.finish(34);

              case 37:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[14, 31, 34, 37]]);
      }));
      return _printReport.apply(this, arguments);
    }

    return {
      modalVisible: modalVisible,
      zUserReportDate: zUserReportDate,
      zTurnoverReportDate: zTurnoverReportDate,
      zUserSimulationReportDate: zUserSimulationReportDate,
      zTurnoverSimulationReportDate: zTurnoverSimulationReportDate,
      disabledDate: disabledDate,
      disabledPrint: disabledPrint,
      printReport: printReport,
      loading: loading
    };
  }
});